function createJsonAccess() {
  return {
    nomeTecnico: "string",
    loginTecnico: "string",
    contrato: "string",
    nomeLider1: "string",
    telefoneLider1: "string",
    addressCity: "string",
    osNumbers: ["string"],
    epoName: "string",
    osDescription: "string",
    nomeLider2: "string",
    nomeLider3: "string",
    nomeLider4: "string",
    telefoneLider2: "string",
    telefoneLider3: "string",
    telefoneLider4: "string",
    numberWo: "string",
  };
}

export default createJsonAccess;
